// @ts-nocheck
export const localeCodes =  [
  "en",
  "de",
  "da",
  "es",
  "fr",
  "it",
  "nl",
  "pt",
  "pl",
  "sl",
  "sv",
  "fi",
  "et"
]
export const localeLoaders = {
  en: [],
  de: [],
  da: [],
  es: [],
  fr: [],
  it: [],
  nl: [],
  pt: [],
  pl: [],
  sl: [],
  sv: [],
  fi: [],
  et: []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    iso: "en",
    name: "English",
    label: "EN",
    language: "en",
    _hreflang: "en",
    _sitemap: "en"
  },
  {
    code: "de",
    iso: "de",
    name: "German",
    label: "DE",
    language: "de",
    _hreflang: "de",
    _sitemap: "de"
  },
  {
    code: "da",
    iso: "da",
    name: "Danish",
    label: "DA",
    language: "da",
    _hreflang: "da",
    _sitemap: "da"
  },
  {
    code: "es",
    iso: "es",
    name: "Spanish",
    label: "ES",
    language: "es",
    _hreflang: "es",
    _sitemap: "es"
  },
  {
    code: "fr",
    iso: "fr",
    name: "French",
    label: "FR",
    language: "fr",
    _hreflang: "fr",
    _sitemap: "fr"
  },
  {
    code: "it",
    iso: "it",
    name: "Italian",
    label: "IT",
    language: "it",
    _hreflang: "it",
    _sitemap: "it"
  },
  {
    code: "nl",
    iso: "nl",
    name: "Dutch",
    label: "NL",
    language: "nl",
    _hreflang: "nl",
    _sitemap: "nl"
  },
  {
    code: "pt",
    iso: "pt",
    name: "Portuguese",
    label: "PT",
    language: "pt",
    _hreflang: "pt",
    _sitemap: "pt"
  },
  {
    code: "pl",
    iso: "pl",
    name: "Polish",
    label: "PL",
    language: "pl",
    _hreflang: "pl",
    _sitemap: "pl"
  },
  {
    code: "sl",
    iso: "sl",
    name: "Slovenian",
    label: "SL",
    language: "sl",
    _hreflang: "sl",
    _sitemap: "sl"
  },
  {
    code: "sv",
    iso: "sv",
    name: "Swedish",
    label: "SV",
    language: "sv",
    _hreflang: "sv",
    _sitemap: "sv"
  },
  {
    code: "fi",
    iso: "fi",
    name: "Finnish",
    label: "FI",
    language: "fi",
    _hreflang: "fi",
    _sitemap: "fi"
  },
  {
    code: "et",
    iso: "et",
    name: "Eesti",
    label: "ET",
    language: "et",
    _hreflang: "et",
    _sitemap: "et"
  }
]
/** client **/

/** client-end **/